import Image from 'next/image';
import React from 'react';
import {
  Etherscan,
  Instagram,
  SocialContainer,
  Website,
  X,
} from '@/components/svg/SocialIcons';
import { BucketType, createBucketURL } from '@/utilities/createBucketUrl';
import { cleanAddress } from '@/utilities/functions';

interface CollectionHeaderProps {
  nftContractAddress: string;
  title: string;
  summary: string;
  twitterHandle: string;
  instagramHandle: string;
  website: string;
  avatarUpdatedAt?: string;
  authed?: boolean;
}

export const CollectionHeader = ({
  nftContractAddress,
  title,
  summary,
  twitterHandle,
  instagramHandle,
  website,
  avatarUpdatedAt,
}: CollectionHeaderProps) => {
  return (
    <div className="flex w-full flex-col items-stretch rounded-2xl md:flex-row md:bg-white ">
      <Image
        className="rounded-2xl md:rounded-none md:rounded-l-2xl "
        width={458}
        height={458}
        alt={title}
        objectFit="cover"
        src={
          cleanAddress(nftContractAddress)
            ? createBucketURL(
                BucketType.Collection,
                cleanAddress(nftContractAddress),
                avatarUpdatedAt
              )
            : ''
        }
      />
      <div className="flex w-[100%] -translate-y-[25px] flex-col justify-between rounded-2xl bg-white px-4 pb-8 pt-6 md:mt-0 md:w-[59%] md:-translate-y-0 md:rounded-none md:bg-transparent md:pl-8 md:pr-6 md:pt-[93px]">
        <div>
          <h1 className="font-gt-haptik text-heading-5-mobile leading-10 text-black md:text-heading-5">
            {title}
          </h1>
          <p className="max-w-[590px] pt-3 text-neutral-50">{summary}</p>
          <div className="flex w-full gap-5 pt-8">
            {twitterHandle && (
              <SocialContainer href={`https://twitter.com/${twitterHandle}`}>
                <X />
              </SocialContainer>
            )}
            {instagramHandle && (
              <SocialContainer
                href={`https://www.instagram.com/${instagramHandle}`}
              >
                <Instagram />
              </SocialContainer>
            )}
            {website && (
              <SocialContainer href={website ?? ''}>
                <Website />
              </SocialContainer>
            )}
            <SocialContainer
              href={`https://etherscan.io/address/${nftContractAddress}`}
            >
              <Etherscan />
            </SocialContainer>
          </div>
        </div>
      </div>
    </div>
  );
};
